// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-f9bc9ffe] .prose img{border-radius:.25rem}", ""]);
// Exports
module.exports = exports;
